import { WindowLocation } from '@gatsbyjs/reach-router';
import Analytics, {
	EventAction,
	EventCategory,
	EventKeys,
	EventLabel,
} from '../../../../services/analytics';
import APIConnector, {
	EnrollmentResponse,
	requestStatus,
} from '../../../hoc/context/api';
import Flow, { FlowStep } from '../../flow/flow';
import { Waiting } from '../components';
import EnrollmentConfirmation from '../components/confirmation/enrollment-confirmation';
import Print from '../components/services/card/views/print';
import { mapper } from '../../../hoc/context/enrollment/mappers/mapper';

export const routes = {
	loading: 'loading',
	confirmed: 'confirmed',
	print: 'confirmed/print',
};

export class ConfirmationFlow extends Flow {
	private dataRequested = false;

	get steps(): FlowStep[] {
		return [
			{
				path: routes.loading,
				component: Waiting,
				flow: this,
			},
			{
				path: routes.confirmed,
				component: EnrollmentConfirmation,
				flow: this,
			},
			{
				path: routes.print,
				component: Print,
				flow: this,
				condition: () => false,
			},
		];
	}

	next(location: WindowLocation) {
		if (location?.pathname === this.uri && !this.dataRequested) {
			this.dataRequested = true;
			const apiConnector = new APIConnector(this.configuration, this.enrollmentCtxt);
			apiConnector.enroll(
				mapper(this.configuration, this.enrollmentCtxt),
				(enrollmentResponse) => {
					console.log('Response', enrollmentResponse);
					this.enrollmentCtxt.enrollmentResponse = enrollmentResponse;
					this.callback(location, enrollmentResponse);
				}
			);
			this.navigate(routes.loading, { replace: true });
		}
	}

	protected callback(location: WindowLocation, response: EnrollmentResponse) {
		if (response.status !== requestStatus.COMPLETED) {
			this.trackConfirmation(response.status, response);
			this.terminate(location, response.status);
		} else {
			this.trackConfirmation(requestStatus.COMPLETED, response);

			this.navigate(routes.confirmed, { replace: true });
		}
	}

	// HELPER FUNCTIONS
	// ----------------------------------------------------------------------------
	private trackConfirmation(type: string, response?: EnrollmentResponse) {
		try {
			const analytics = Analytics.getInstance(this.configuration.mock);
			const MILLISECONDS = 1000;
			analytics.sendEvent({
				[EventKeys.EventCategory]: EventCategory.Confirmation,
				[EventKeys.EventAction]: EventAction.Result,
				[EventKeys.EventLabel]: type,
				[EventKeys.ConfirmationStatus]: type,
				[EventKeys.APIResponseTime]: response?.time
					? response?.time / MILLISECONDS
					: 0,
				[EventKeys.APIStatus]:
					requestStatus.COMPLETED === type
						? EventLabel.Complete
						: EventLabel.Incomplete,
				[EventKeys.APIEnrollmentId]:
				response?.patientId || EventLabel.EnrollmentId,
			});
		} catch (err) {
			console.error('Error sending GA Events (Result-confirmation', err);
		}
	}
}

export default ConfirmationFlow;
